// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3zzRGML-3UD7wWvYp_NH15 {\n  letter-spacing: var(--paragraph-letter-spacing);\n  text-align: center;\n}\n", ""]);
// Exports
exports.locals = {
	"content": "_3zzRGML-3UD7wWvYp_NH15"
};
module.exports = exports;
